import { tokenRequest } from './authConfig';
import logger from 'SERVICES/logger';
import { ROUTES } from 'CONSTANTS/appConstants';
import { IPublicClientApplication } from '@azure/msal-browser';

let msalInstance: IPublicClientApplication = {} as IPublicClientApplication;
const INTERACTION_REQUIRED_ERROR = 'InteractionRequiredAuthError';

export const setMsalInstance = (msal: IPublicClientApplication) => {
  msalInstance = msal;
};

export const getStreamerIdToken = async () => {
  const path = window.location.pathname;
  if (path.startsWith(ROUTES.STREAMER)) {
    const allAccounts = msalInstance.getAllAccounts();
    let tokenError = '';
    if (allAccounts.length > 0) {
      const [account] = allAccounts;
      try {
        const tokenData = await msalInstance.acquireTokenSilent({ ...tokenRequest, account });
        return tokenData.idToken;
      } catch (error: any) {
        tokenError = error?.name;
      }

      // If the acquireTokenSilent fails and returns InteractionRequiredAuthError error
      // We need to call acquireTokenPopup to get token
      // AADB2C90077
      // https://docs.microsoft.com/en-us/azure/active-directory-b2c/error-codes
      if (tokenError === INTERACTION_REQUIRED_ERROR) {
        // Trying to take token from pop-up
        try {
          const tokenInformation = await msalInstance.acquireTokenPopup({
            ...tokenRequest,
            account,
          });
          return tokenInformation.idToken;
        } catch (err) {
          logger.error('Error while acquireTokenPopup', err);
        }
      }
    }
  }
  return null;
};

export const logout = async () => {
  const allAccounts = msalInstance.getAllAccounts();
  if (allAccounts.length > 0) {
    const [account] = allAccounts;

    try {
      msalInstance.logoutRedirect({
        account,
        onRedirectNavigate: () => {
          // Return false to implement local logout
          // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/logout.md#requirements-for-front-channel-logout-page
          return false;
        },
      });
    } catch (err) {
      logger.error(err);
    }
  }
};
